import {
  View,
  StyleSheet,
  LayoutChangeEvent,
  // BackHandler,
  RefreshControl,
  Animated,
} from 'react-native';
import {NativeTouchableOpacity} from '@basicComponents/touchable-opacity';
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import {LazyImageBackground} from '@basicComponents/image';
import theme from '@style';
import {
  designToDp,
  goCS,
  goTo,
  navigate,
  toAgentApply,
  useResponsiveDimensions,
  inApp,
  getVersionName,
} from '@utils';
import Text from '@basicComponents/text';
import {
  MeListItem,
  commissionIcon,
  customerServiceIcon,
  languagesIcon,
  moneyIcon,
  notificationsIcon,
  passwordIcon,
  resultHistoryIcon,
  transactionsIcon,
  updateIcon,
  gifCodeIcon,
} from '@businessComponents/list-item';
import {
  IUserInfo,
  MessageCountInfo,
  postUserInfo,
} from '@services/global.service';
import {useConfirm, ToastType} from '@basicComponents/modal';
import {useLanguageModal} from '@businessComponents/language';
import {useFocusEffect} from '@react-navigation/native';
import globalStore from '@/services/global.state';
import {toLogin, topBackground} from './me.variable';
import MeHeader from './me-header';
import MeAmount from './me-amount';
import MeUser from './me-user';
import {FadeInView} from '@basicComponents/animations';
import {NoMoreData} from '@/components/basic/default-page';
import Spin from '@/components/basic/spin';
import {useTranslation} from 'react-i18next';
import MeRowMenu from './me-row-menu';
import {getNoticeCheck} from '../home/home.service';
import Tag from '@/components/basic/tag';
import {BasicObject} from '@/types';
import {checkUpdate} from '@/utils/update';
import {setUniqueId} from '@/utils/moengage';
import MePromotions from './me-promotions';
import {VipUpgradeContext} from '@/common-pages/vip/provider/vip-upgrade-provider';

import {ReactComponent as EmailIcon} from '@/assets/icons/me/email.svg';
import Clipboard from '@react-native-clipboard/clipboard';
import GiftModal from './me-gift';
import VipHalfCard, {VipInfo} from '@/common-pages/vip/vip-half-card';
import {trackEvent} from '@/utils/track-event';

const {
  flex,
  overflow,
  padding,
  paddingSize,
  font,
  margin,
  borderRadius,
  background,
} = theme;

const topClipHeight = 44;

/** TODO 单个文件过大,需要拆解 */
const Me = () => {
  const {i18n} = useTranslation();
  const [login, setLogin] = useState<boolean>(false);
  const scrollAnim = useRef(new Animated.Value(0)).current;
  const {width: screenWidth} = useResponsiveDimensions();
  const topBlockWidth = screenWidth - 4 * paddingSize.m;
  const [user, setUser] = useState<IUserInfo>();
  const {renderModal: renderConfirmModal, show: confirmShow} = useConfirm();
  const {renderModal: renderLanguageModal, show: languageShow} =
    useLanguageModal();
  const [showNoMenu] = useState<boolean>(false);
  const [messageCountInfo, setMessageCountInfo] = useState<MessageCountInfo>({
    messageTotalCount: 0,
    sysMessageCount: 0,
    sysUserMessageCount: 0,
  });

  const [userAreaY, setUserAreaY] = useState<number>(0);
  const vipCardRef = useRef<{init: () => void}>(null);
  const [vip, setVip] = useState<VipInfo>();

  const [pageLoading, setPageLoading] = useState(false);
  const notYetWarning = {
    type: ToastType.warning,
    message: i18n.t('warning.unopen'),
  };
  const [noticeMap, setNoticeMap] = useState<BasicObject>({
    FREE_LOTTERY: 0,
    REBATE: 0,
    LUCKY_SPIN: 0,
  });
  const refresh = async (loading: boolean = true) => {
    if (!login) {
      setUser(undefined);
      globalStore.userInfo = null;
      setMessageCountInfo({
        messageTotalCount: 0,
        sysMessageCount: 0,
        sysUserMessageCount: 0,
      });
      updateVipCard();
      return;
    }
    globalStore.refreshNotification.next();
    loading && setPageLoading(true);
    try {
      const userInfo = await postUserInfo();
      setUser(userInfo);
      globalStore.userInfo = userInfo;
      updateVipCard();
    } finally {
      setPageLoading(false);
      setRefreshing(false);
    }
  };
  const doNotice = () => {
    if (login) {
      getNoticeCheck()
        .then(noticeList => {
          const newNoticeMap: BasicObject = {};
          Object.keys(noticeMap).forEach(key => {
            const notice = noticeList.find(item => item.noticeKey === key);
            if (notice) {
              newNoticeMap[key] = notice.noticeCount;
            }
          });
          setNoticeMap(newNoticeMap);
        })
        .catch(() => {
          setNoticeMap({
            FREE_LOTTERY: 0,
            REBATE: 0,
            LUCKY_SPIN: 0,
          });
        });
    } else {
      setNoticeMap({
        FREE_LOTTERY: 0,
        REBATE: 0,
        LUCKY_SPIN: 0,
      });
    }
  };
  const updateVipCard = useCallback(() => {
    vipCardRef.current?.init();
  }, []);
  const vipUpgradeProvider = useContext(VipUpgradeContext);

  const handleFocusEffect = useCallback(() => {
    const sub = globalStore.tokenSubject.subscribe(token => {
      setLogin(!!token);
      if (token) {
        globalStore.amountCheckOut.next({});
      }
    });
    return () => {
      sub.unsubscribe();
    };
  }, []);

  useFocusEffect(
    useCallback(() => {
      vipUpgradeProvider.showVipUpgrade(() => {
        updateVipCard();
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [vipUpgradeProvider]),
  );

  useEffect(() => {
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [login]);

  // useFocusEffect(
  //   useCallback(() => {
  //     if (login) {
  //       getVipAboutRewardStatus();
  //     }
  //   }, [login]),
  // );
  useFocusEffect(handleFocusEffect);

  useFocusEffect(
    useCallback(() => {
      doNotice();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [login]),
  );

  const handleMoneyLayout = (e: LayoutChangeEvent) => {
    setUserAreaY(e.nativeEvent.layout.y);
  };

  const handleRefresh = () => {
    if (!login) {
      goTo('Login');
      return;
    }
    refresh();
  };

  const toRecharge = () => {
    if (!login) {
      toLogin();
      return;
    }
    // 跳转recharge
    goTo('Recharge');
  };

  const toWithdraw = () => {
    if (!login) {
      toLogin();
      return;
    }
    // 跳转withdraw
    goTo('Withdraw');
  };

  const toTransfer = () => {
    if (!login) {
      toLogin();
      return;
    }
    goTo('Transfer');
  };

  const toWallet = () => {
    if (!login) {
      toLogin();
      return;
    }
    goTo('Wallet');
  };

  const toResults = () => {
    goTo('Result');
  };

  const toCommission = () => {
    if (!login) {
      toLogin();
      return;
    }
    // 跳转commission
    // goTo('Invitation');
    goTo('ProxyCommissionDetail', {
      userId: user?.userId,
      agentLevel: user?.agentLevel,
    });
  };

  const toTransactions = () => {
    if (!login) {
      toLogin();
      return;
    }
    goTo('Transactions');
  };

  const toMyBets = () => {
    if (!login) {
      toLogin();
      return;
    }
    goTo('Bets');
  };

  const toNotify = () => {
    if (!login) {
      goTo('Login');
    } else {
      goTo('Notification');
    }
  };

  const toLanguage = () => {
    languageShow();
  };

  const doLogout = () => {
    // logout
    confirmShow(i18n.t('alert.logout'), i18n.t('alert.sureLogout'), () => {
      trackEvent('logout');
      setUniqueId('');
      globalStore.token = null;
      globalStore.userInfo = null;
      toLogin();
    });
  };

  const toSetPassword = () => {
    if (!login) {
      toLogin();
      return;
    }
    navigate('SetPassword');
  };

  const toAgency = () => {
    if (!login) {
      toAgentApply();
      return;
    }
    if (user?.isAgent === 1) {
      goTo('ProxyHome');
    } else {
      toAgentApply();
    }
  };

  const handleUser = () => {
    if (!login) {
      toLogin();
      return;
    }
    if (showNoMenu) {
      globalStore.globalTotal.next(notYetWarning);
    }
  };
  const [refreshing, setRefreshing] = useState<boolean>(false);
  const giftModalRef = useRef<any>();
  return (
    <FadeInView>
      {/* TODO 这里的滚动方案需要优化,以及文件过大需要拆分 */}
      <Spin loading={pageLoading} style={[theme.fill.fill]}>
        <Animated.ScrollView
          onScroll={Animated.event(
            [
              {
                nativeEvent: {
                  contentOffset: {y: scrollAnim},
                },
              },
            ],
            {useNativeDriver: true},
          )}
          scrollEventThrottle={1}
          refreshControl={
            <RefreshControl
              refreshing={refreshing}
              onRefresh={() => {
                setRefreshing(true);
                refresh(false);
              }}
            />
          }>
          <View
            style={[
              flex.col,
              flex.end,
              {
                marginBottom: -40,
              },
              // {height: (screenWidth / 375) * (372 - topClipHeight + 20)},
            ]}>
            <LazyImageBackground
              occupancy={'transparent'}
              imageUrl={topBackground}
              width={screenWidth}
              // height={(screenWidth / 375) * 372}
              style={[
                padding.m,
                // padding.lrm,
                // styles.topBg,
                overflow.hidden,
                // padding.btmm,
              ]}>
              <View style={[padding.m]}>
                {/* 用户块 */}
                <MeUser
                  login={login}
                  user={user}
                  vipLevel={vip?.level || 0}
                  onUser={handleUser}
                  showNoMenu={showNoMenu}
                />
                <div className="-mb-6">
                  <VipHalfCard
                    ref={vipCardRef}
                    login={login}
                    onVipUpdate={val => {
                      if (val) {
                        setVip(val);
                      }
                    }}
                  />
                </div>
                {/* 钱包区域 */}
                <MeAmount
                  login={login}
                  onLayout={handleMoneyLayout}
                  topBlockWidth={topBlockWidth}
                  user={user}
                  onRecharge={toRecharge}
                  onWithdraw={toWithdraw}
                  onRefresh={handleRefresh}
                  onWallet={toWallet}
                />
                {/* VIP区域，直接使用当前的TouchableOpacity组件会导致安卓的vip图标被遮挡，故直接使用原生的 */}
              </View>
            </LazyImageBackground>
          </View>
          <MeRowMenu
            onRecharge={toRecharge}
            onTransfer={toTransfer}
            onWithdraw={toWithdraw}
            login={login}
            luckyspinFree={noticeMap.LUCKY_SPIN}
            refresh={() => refresh(false)}
          />
          <MePromotions />
          <View style={[padding.lrl, padding.btmxxl, background.lightGrey]}>
            {/* 列表区域 */}
            <View
              style={[
                background.white,
                padding.lrm,
                padding.tbl,
                borderRadius.m,
                overflow.hidden,
                margin.btml,
              ]}>
              <MeListItem
                icon={gifCodeIcon}
                title={i18n.t('me.bottom.gifCode')}
                onPress={() => {
                  if (!login) {
                    toLogin();
                    return;
                  }
                  giftModalRef.current?.show();
                }}
                rightContent={
                  <div className="animate-breathe">
                    <Tag
                      content="HOT"
                      type="badge"
                      backgroundColor="#FF4D4D"
                      style={{
                        paddingVertical: 6,
                        width: 30,
                        height: 14,
                        borderRadius: 20,
                      }}
                    />
                  </div>
                }
              />
              <MeListItem
                icon={require('@assets/icons/me/proxy.webp')}
                title={i18n.t('me.bottom.proxy')}
                rightContent={
                  <View
                    style={[theme.flex.center, theme.padding.lrxs, styles.new]}>
                    <Text fontSize={8} style={[theme.font.white]}>
                      {i18n.t('me.new')}
                    </Text>
                  </View>
                }
                onPress={toAgency}
              />
              <MeListItem
                icon={resultHistoryIcon}
                title={i18n.t('me.bottom.resultHistory')}
                onPress={toResults}
              />

              <MeListItem
                icon={moneyIcon}
                title={i18n.t('me.bottom.myBets')}
                onPress={toMyBets}
              />

              <MeListItem
                icon={transactionsIcon}
                title={i18n.t('me.bottom.myTransactions')}
                onPress={toTransactions}
              />
              <MeListItem
                icon={commissionIcon}
                title={i18n.t('me.bottom.commission')}
                onPress={toCommission}
              />
            </View>
            <View
              style={[
                background.white,
                padding.lrm,
                padding.tbl,
                borderRadius.m,
                overflow.hidden,
                margin.btml,
              ]}>
              <MeListItem
                icon={notificationsIcon}
                title={i18n.t('me.bottom.notify')}
                rightContent={
                  messageCountInfo && messageCountInfo.messageTotalCount ? (
                    <Tag content={messageCountInfo.messageTotalCount} />
                  ) : null
                }
                onPress={toNotify}
              />

              <MeListItem
                icon={passwordIcon}
                title={i18n.t('me.bottom.password')}
                onPress={toSetPassword}
              />

              <MeListItem
                icon={languagesIcon}
                title={i18n.t('me.bottom.lang')}
                onPress={toLanguage}
              />
              <MeListItem
                icon={customerServiceIcon}
                title={i18n.t('me.bottom.customer')}
                onPress={goCS}
              />
              {inApp && (
                <MeListItem
                  icon={updateIcon}
                  title={i18n.t('me.bottom.update')}
                  rightContent={
                    <Text style={[font.secAccent, font.fs]}>
                      {getVersionName()}
                    </Text>
                  }
                  onPress={() => {
                    checkUpdate(true);
                  }}
                />
              )}
              {false && (
                <div className="flex flex-col text-xs items-center py-3 gap-2 border-t border-t-line">
                  <p>{i18n.t('me.tip.anyquery')}</p>
                  <p
                    className="text-c1 flex flex-row gap-2 text-sm items-center"
                    onClick={() => {
                      Clipboard.setString('support@singamlottery.in');
                      globalStore.globalTotal.next({
                        type: 'success',
                        message: i18n.t('tip.copysuccess'),
                      });
                    }}>
                    <EmailIcon className="size-4 text-c1" />
                    <span>support@singamlottery.in</span>
                  </p>
                </div>
              )}
            </View>
            {login && (
              <NativeTouchableOpacity onPress={doLogout}>
                <View
                  style={[
                    background.white,
                    padding.lrm,
                    padding.tbl,
                    borderRadius.m,
                    overflow.hidden,
                    margin.btmxxl,
                  ]}>
                  <Text style={[font.second, font.fm, font.bold, font.center]}>
                    {i18n.t('me.bottom.logout')}
                  </Text>
                </View>
              </NativeTouchableOpacity>
            )}
            <NoMoreData text="" />
          </View>
        </Animated.ScrollView>
        <MeHeader
          user={user}
          userAreaY={userAreaY}
          login={login}
          scrollAnim={scrollAnim}
          onUser={handleUser}
          showNoMenu={showNoMenu}
        />
      </Spin>
      {renderConfirmModal}
      {renderLanguageModal}
      <GiftModal ref={giftModalRef} />
    </FadeInView>
  );
};

const styles = StyleSheet.create({
  topBg: {
    /** 此处由于裁剪高度是根据宽度按比例换算的，所以这边也需要按照比例换算paddingTop */
    paddingTop: designToDp(topClipHeight) + paddingSize.m,
  },
  opacity: {
    opacity: 0.5,
  },
  lightOpacity: {
    opacity: 0.8,
  },
  bottomNav: {
    height: designToDp(80),
  },
  bottomNavItem: {
    width: designToDp(104),
  },
  new: {
    backgroundColor: '#FF4D4D',
    borderRadius: 20,
    paddingVertical: 2,
  },
});

export default Me;
